webpackJsonp([61],{

/***/ "yTSi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-payment-details-enter-card_513814fd7d5bcf6943426ba4143d0e9b.html";

/***/ }),

/***/ "z6GX":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionPaymentDetailsEnterCard = (function () {
    function SubscriptionPaymentDetailsEnterCard() {
    }
    return SubscriptionPaymentDetailsEnterCard;
}());
angular.module('animatronApp.SubscriptionPaymentDetailsEnterCard', [])
    .component('subscriptionPaymentDetailsEnterCard', {
    controller: SubscriptionPaymentDetailsEnterCard,
    templateUrl: __webpack_require__("yTSi")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/61-c7c98a0cc108ea8b91f3.min.js